var map = {
	"./Approved.svg": 3849,
	"./AwaitingParts.svg": 3850,
	"./Closed.svg": 3851,
	"./Completed.svg": 3852,
	"./Excel.svg": 3853,
	"./Exportall_grey.svg": 3854,
	"./Exportall_grey_circle.svg": 3855,
	"./InProgress.svg": 3856,
	"./New.svg": 3857,
	"./View_Pic_Grey.svg": 3858,
	"./accident.svg": 3859,
	"./account.svg": 3860,
	"./addOrange.svg": 3861,
	"./addUser.svg": 3862,
	"./addVehicle.svg": 3863,
	"./address.svg": 3864,
	"./alert.svg": 3865,
	"./all_active.svg": 3866,
	"./all_active_es.svg": 3867,
	"./arrow-down.svg": 3868,
	"./arrow-up.svg": 3869,
	"./arrowRight.svg": 3870,
	"./awaiting_parts_grey.svg": 3871,
	"./awaiting_parts_orange.svg": 3872,
	"./back-btn.svg": 3873,
	"./back-button-grey.svg": 3874,
	"./backButton.svg": 3875,
	"./bills_of_landing_active.svg": 3876,
	"./bills_of_landing_active_es.svg": 3877,
	"./bobTail.svg": 3878,
	"./book-solid.svg": 3879,
	"./boxTruck.svg": 3880,
	"./calanderIcon.svg": 3881,
	"./cameraSelected.svg": 3882,
	"./camera_selected.svg": 3883,
	"./chat-icon.svg": 3884,
	"./circle-Exportall_grey.svg": 3885,
	"./circle-export.svg": 3886,
	"./circle-exportUser.svg": 3887,
	"./circle-import.svg": 3888,
	"./circle-importUser.svg": 3889,
	"./circle-viewall.svg": 3890,
	"./clearAll.svg": 3891,
	"./close-popup.svg": 3892,
	"./closeMap.svg": 3893,
	"./closed-Orange.svg": 3894,
	"./closed-grey.svg": 3895,
	"./clusterIcon.svg": 3896,
	"./communication_records_active.svg": 3897,
	"./communication_records_active_es.svg": 3898,
	"./company.svg": 3899,
	"./companyIcon.svg": 3900,
	"./complete-Orange.svg": 3901,
	"./complete-grey.svg": 3902,
	"./csa.svg": 3903,
	"./csaSnapshot.svg": 3904,
	"./dailyDocuments.svg": 3905,
	"./dashboard.svg": 3906,
	"./dashboardIcon.svg": 3907,
	"./date.svg": 3908,
	"./delete.svg": 3909,
	"./deleteCircle.svg": 3910,
	"./delivery_receipts_active.svg": 3911,
	"./delivery_receipts_active_es.svg": 3912,
	"./departments.svg": 3913,
	"./departmetEdit.svg": 3914,
	"./developer.svg": 3915,
	"./direction.svg": 3916,
	"./dispatch_records_active.svg": 3917,
	"./dispatch_records_active_es.svg": 3918,
	"./document.svg": 3919,
	"./documents.svg": 3920,
	"./dot.svg": 3921,
	"./dotAudit.svg": 3922,
	"./dotauditIcon.svg": 3923,
	"./downarrowIcon.svg": 3924,
	"./download.svg": 3925,
	"./downloadCenter.svg": 3926,
	"./downloadCenterMenu.svg": 3927,
	"./driver-behaviour.svg": 3928,
	"./driver.svg": 3929,
	"./dryVan.svg": 3930,
	"./dtc.svg": 3931,
	"./dualCam.svg": 3932,
	"./dump.svg": 3933,
	"./edit.svg": 3934,
	"./editLogIcon.svg": 3935,
	"./editSvg.svg": 3936,
	"./en.svg": 3937,
	"./es.svg": 3938,
	"./excelNew.svg": 3939,
	"./export-grey.svg": 3940,
	"./export.svg": 3941,
	"./exportUser.svg": 3942,
	"./feedback.svg": 3943,
	"./file-pdf-regular.svg": 3944,
	"./filter.svg": 3945,
	"./flatBed.svg": 3946,
	"./fleet.svg": 3947,
	"./fleetCompanies.svg": 3948,
	"./fleetdriverIcon.svg": 3949,
	"./fleetvehiclesIcon.svg": 3950,
	"./fletBed.svg": 3951,
	"./fr.svg": 3952,
	"./fuel.svg": 3953,
	"./full.svg": 3954,
	"./hamburger.svg": 3955,
	"./help-icon.svg": 3956,
	"./historyLogs.svg": 3957,
	"./icon-delete.svg": 3958,
	"./icon-export.svg": 3959,
	"./icon-menu-logs.svg": 3960,
	"./ifta.svg": 3961,
	"./import.svg": 3962,
	"./importUser.svg": 3963,
	"./in_progress_grey.svg": 3964,
	"./in_progress_orange.svg": 3965,
	"./infoTruck.svg": 3966,
	"./inspection-dvir.svg": 3967,
	"./inspection.svg": 3968,
	"./key.svg": 3969,
	"./leftArrow.svg": 3970,
	"./location.svg": 3971,
	"./locationMap.svg": 3972,
	"./log.svg": 3973,
	"./logEdit.svg": 3974,
	"./logHistory.svg": 3975,
	"./logoutIcon.svg": 3976,
	"./logs.svg": 3977,
	"./logsIcon.svg": 3978,
	"./mack.svg": 3979,
	"./mail.svg": 3980,
	"./main_camera.svg": 3981,
	"./mappinPopup.svg": 3982,
	"./menu_companies.svg": 3983,
	"./menu_dailyLog.svg": 3984,
	"./menu_reports.svg": 3985,
	"./menu_reseller.svg": 3986,
	"./menu_vehicle.svg": 3987,
	"./messageSender.svg": 3988,
	"./messaging.svg": 3989,
	"./new_login.svg": 3990,
	"./ninePin.svg": 3991,
	"./nonEdit.svg": 3992,
	"./notFull.svg": 3993,
	"./not_started_grey.svg": 3994,
	"./not_started_orange.svg": 3995,
	"./otherTrailer.svg": 3996,
	"./otherTruck.svg": 3997,
	"./other_documents_active.svg": 3998,
	"./other_documents_active_es.svg": 3999,
	"./overview.svg": 4000,
	"./page-first.svg": 4001,
	"./page-last.svg": 4002,
	"./page-next.svg": 4003,
	"./page-prev.svg": 4004,
	"./phone.svg": 4005,
	"./pickup.svg": 4006,
	"./pneumaticTrailer.svg": 4007,
	"./policy.svg": 4008,
	"./popupClose.svg": 4009,
	"./popupConfirm.svg": 4010,
	"./popupDelete.svg": 4011,
	"./privatePassenger.svg": 4012,
	"./qbdii.svg": 4013,
	"./receipts_active.svg": 4014,
	"./receipts_active_es.svg": 4015,
	"./reeferTrailer.svg": 4016,
	"./refreshCircle.svg": 4017,
	"./renewal.svg": 4018,
	"./repair.svg": 4019,
	"./reportIcon.svg": 4020,
	"./reports.svg": 4021,
	"./save-regular.svg": 4022,
	"./scoreCard.svg": 4023,
	"./searchGrey.svg": 4024,
	"./selectedConnection.svg": 4025,
	"./share.svg": 4026,
	"./sixPin.svg": 4027,
	"./sort.svg": 4028,
	"./speedometer.svg": 4029,
	"./spotlightGreen.svg": 4030,
	"./spotlightGrey.svg": 4031,
	"./spotlightRed.svg": 4032,
	"./straightTruck.svg": 4033,
	"./supportIcon.svg": 4034,
	"./switch.svg": 4035,
	"./tankerTrailer.svg": 4036,
	"./tick.svg": 4037,
	"./time.svg": 4038,
	"./timePicker.svg": 4039,
	"./toggle-off.svg": 4040,
	"./toggle-on.svg": 4041,
	"./tools.svg": 4042,
	"./tractorDayCab.svg": 4043,
	"./tractorSleeper.svg": 4044,
	"./undelete.svg": 4045,
	"./unsaved.svg": 4046,
	"./update.svg": 4047,
	"./upload.svg": 4048,
	"./usdot.svg": 4049,
	"./user.svg": 4050,
	"./userprofileIcon.svg": 4051,
	"./users.svg": 4052,
	"./vacuumTrailer.svg": 4053,
	"./vacuumTruck.svg": 4054,
	"./van.svg": 4055,
	"./vehicle-behaviour.svg": 4056,
	"./vehicle.svg": 4057,
	"./vehicleIcon.svg": 4058,
	"./viewArrow.svg": 4059,
	"./viewDocument.svg": 4060,
	"./viewReports.svg": 4061,
	"./viewStatus.svg": 4062,
	"./viewallMap.svg": 4063,
	"./violation.svg": 4064,
	"./volvo.svg": 4065,
	"./weigh_tickets_active.svg": 4066,
	"./weigh_tickets_active_es.svg": 4067,
	"./whitecheck_new.svg": 4068
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3848;